import React from "react";
import { motion } from "framer-motion";

const PlatformAndAIWorkforceSlide = () => {
  return (
    <div className="h-full w-full bg-slate-50 flex flex-col items-center justify-center p-10 relative overflow-hidden font-sans">
      {/* Animated gradient blobs */}
      <motion.div
        animate={{
          x: [0, 80, -40, 0],
          y: [0, -60, 40, 0],
          scale: [1, 1.15, 0.95, 1],
        }}
        transition={{ duration: 18, repeat: Infinity, ease: "easeInOut" }}
        className="absolute top-[-10%] left-[-10%] w-[700px] h-[700px] bg-blue-200/50 rounded-full blur-[120px]"
      />
      <motion.div
        animate={{
          x: [0, -60, 40, 0],
          y: [0, 50, -30, 0],
          scale: [1, 1.1, 1.05, 1],
        }}
        transition={{ duration: 22, repeat: Infinity, ease: "easeInOut", delay: 2 }}
        className="absolute bottom-[-15%] right-[-10%] w-[800px] h-[800px] bg-indigo-200/50 rounded-full blur-[140px]"
      />
      <motion.div
        animate={{
          x: [0, 50, -50, 0],
          y: [0, -40, 60, 0],
          opacity: [0.4, 0.6, 0.4],
        }}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        className="absolute top-[30%] right-[15%] w-[400px] h-[400px] bg-violet-200/40 rounded-full blur-[100px]"
      />
      <motion.div
        animate={{
          x: [0, -40, 60, 0],
          y: [0, 30, -50, 0],
          opacity: [0.3, 0.55, 0.3],
        }}
        transition={{ duration: 20, repeat: Infinity, ease: "easeInOut", delay: 3 }}
        className="absolute bottom-[20%] left-[15%] w-[450px] h-[450px] bg-sky-200/40 rounded-full blur-[110px]"
      />

      {/* Subtle grid */}
      <div className="absolute inset-0 bg-[radial-gradient(#cbd5e1_1px,transparent_1px)] [background-size:40px_40px] opacity-30 [mask-image:radial-gradient(ellipse_70%_60%_at_50%_50%,black_40%,transparent_90%)]" />

      {/* Soft highlight behind text */}
      <motion.div
        animate={{ opacity: [0.3, 0.55, 0.3] }}
        transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        className="absolute w-[1100px] h-[500px] bg-white/60 rounded-full blur-[100px]"
      />

      <div className="max-w-[1200px] w-full relative z-10 flex flex-col items-center justify-center text-center">
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="text-3xl md:text-[40px] lg:text-[52px] font-extrabold text-slate-900 leading-[1.15] tracking-tight"
        >
          By replacing <span className="text-slate-900 font-extrabold">10+ softwares</span> with{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 whitespace-nowrap">
            1 unified system
          </span>
          , and mobilizing <span className="text-slate-900 font-extrabold">20+ AI products</span> to handle the{" "}
          <span className="text-slate-900 font-extrabold">40+ tasks</span> your staff runs today, the{" "}
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-indigo-600 to-violet-600 whitespace-nowrap">
            Asha AI OS
          </span>{" "}
          helps you cross the{" "}
          <span className="relative inline-block">
            <span className="relative z-10 text-slate-900 font-extrabold">
              atomic automation threshold
            </span>
            <span className="absolute left-0 right-0 bottom-0 h-[9px] bg-blue-200/70 -z-0 rounded" />
          </span>{" "}
          — so you can unlock the{" "}
          <span className="relative inline-block">
            <span className="relative z-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-indigo-600 font-extrabold">
              50%+ growth opportunity
            </span>
            <span className="absolute left-0 right-0 bottom-0 h-[9px] bg-indigo-200/70 -z-0 rounded" />
          </span>{" "}
          sitting just beyond your bandwidth.
        </motion.h1>
      </div>
    </div>
  );
};

export default PlatformAndAIWorkforceSlide;
